import ContactTypes from '../contact/contact.types';
import { mergeAttributesIntoContact, mergeAcwAttributesIntoContact } from '../contact/contact.utils';
import ContactsTypes from './contacts.types';
import ContactState from '../contact/contact.state';
import AnyAction from 'store/anyActions';
import { isEmpty } from 'utils';

export default function (state: ContactState[], action: AnyAction): ContactState[] | [] {
    switch (action.type) {
        case ContactsTypes.ADD_CONTACT: {
            const isEqualObject = state.some(c => c.ID === action.payload.ID);
            const newState = isEqualObject ? state : [...state, action.payload];
            return newState;
        }
        case ContactsTypes.FILTER_CONTACTS:
            return state.filter(c => c.ID !== action.payload);
        case ContactTypes.UPDATE_ACW_ATTRIBUTES: {
            if (!action.payload.ID) return state;
            const restState = state.filter(c => c.ID !== action.payload.ID);
            const activeContact = state.find(c => c.ID === action.payload.ID);
            return [...restState, { ...activeContact!, acwAttributes: action.payload.acwAttributes }];
        }
        case ContactTypes.UPDATE_CONTACT_ATTRIBUTES: {
            if (!action.payload.ID) return state;
            const restState = state.filter(c => c.ID !== action.payload.ID);
            const activeContact = state.find(c => c.ID === action.payload.ID);
            if (!activeContact || isEmpty(activeContact)) return state;
            return [...restState, mergeAttributesIntoContact(activeContact!, action.payload.attributes)];
        }
        case ContactTypes.UPDATE_CONTACT: {
            const restState = state.filter(c => c.ID !== action.payload.ID);
            return [...restState, action.payload];
        }
        default:
            return state || [];
    }
}
